// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#a)">
      <rect width={32} height={32} fill="#18BF88" rx={16} />
      <rect
        width={30}
        height={30}
        x={1}
        y={1}
        stroke="#18BF88"
        strokeWidth={2}
        rx={15}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M22.7973 9.85615L13.2506 19.0695L10.7173 16.3628C10.2506 15.9228 9.51729 15.8962 8.98396 16.2695C8.46396 16.6562 8.31729 17.3361 8.63729 17.8828L11.6373 22.7628C11.9306 23.2162 12.4373 23.4962 13.0106 23.4962C13.5573 23.4962 14.0773 23.2162 14.3706 22.7628C14.8506 22.1361 24.0106 11.2161 24.0106 11.2161C25.2106 9.98948 23.7573 8.90948 22.7973 9.84282V9.85615Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width={32} height={32} fill="#fff" rx={16} />
      </clipPath>
    </defs>
  </svg>
);
const IconTickFilled = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconTickFilled;
